import { FormStep } from "@components/PatientForms/FormContext/types";
import { eatingHabitsSchema, eatingHabitsValidation, emptyRecentConsumption } from "@components/PatientForms/categories/EatingHabits";
import { exerciseHistorySchema, exerciseHistoryValidation } from "@components/PatientForms/categories/ExerciseHistory";
import { medicationFeedbackValidation } from "@components/PatientForms/categories/MedicationFeedback";
import { medicationFeedbackSchema } from "@components/PatientForms/categories/MedicationFeedback";
import { medicationsSchema, medicationsValidation, setMedicationResponsesToNull, handleDeactivateMedications } from "@components/PatientForms/categories/Medications";
import { currentHealthSchema, emptyRecentSymptoms, reviewOfSystemsValidation } from "@components/PatientForms/categories/ReviewOfSystems";
import { weightLossProgressValidation, weightLossProgressSchema } from "@components/PatientForms/categories/WeightLossProgress";


export const steps: FormStep[] = [
  {
    id: "physiology-review",
    title: "Physiology Review",
    category: "reviewOfSystems",
    schema: currentHealthSchema,
    validation: reviewOfSystemsValidation,
    onLoadData: emptyRecentSymptoms,
  },
  {
    id: "medications",
    title: "Medications",
    category: "medications",
    schema: medicationsSchema,
    validation: medicationsValidation,
    onLoadData: setMedicationResponsesToNull,
    onSubmit: handleDeactivateMedications,
  },
  {
		id: "medication-feedback",
		title: "Medication Feedback",
		category: "medicationFeedback",
		schema: medicationFeedbackSchema,
		validation: medicationFeedbackValidation,
	},
  {
    id: "exercise-history",
    title: "Exercise History",
    category: "exerciseHistory",
    schema: exerciseHistorySchema,
    validation: exerciseHistoryValidation,
  },
  {
		id: "weight-loss-progress",
		title: "Weight Loss Progress",
		category: "weightLossProgress",
		schema: weightLossProgressSchema,
		validation: weightLossProgressValidation,
	},
];